
import React from 'react';
// Inicializar métricas lo antes posible (sin bloquear render)
import('@core/metrics/webVitals').then(mod => { mod.initWebVitals?.(); }).catch(() => {});
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// Cargar sólo subsets latinos útiles para reducir assets
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/crimson-text/latin-400.css";
import "@fontsource/crimson-text/latin-700.css";

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Debug helper — solo en desarrollo, no se incluye en el bundle de producción
if (import.meta.env.DEV) {
  import('./debug/registerWrlensTools')
    .then(({ registerDevTools }) => registerDevTools())
    .catch(() => {})
}

// Helpers de diagnóstico disponibles en TODOS los entornos (incluyendo producción)
import('./debug/registerWrlensTools')
  .then(({ registerGlobalTools }) => registerGlobalTools())
  .catch(() => {})
